import { lazy } from 'react';
import CompanyAcc from 'pages/Industry/CompanyAccount.jsx';
// project imports
import Loadable from 'components/Loadable';
import DashboardLayout from 'layout/Dashboard';
import ProtectedRoute from 'components/ProtectedRoute';
import AppointmentList from '../pages/AppointmentList';
import AppoinmentTest from './AppoinmentTest';
import UserList from '../pages/Industry/UserList';
import TestimonialsList from '../pages/TestimonialsList';
import CompanySettings from '../pages/CompanySettings';
import ImportBookings from '../pages/ImportBookings';
import WebsiteContent from '../pages/WebsiteContent';
import OfflineAppointment from '../pages/OfflineAppointment';
import ImportProspects from '../pages/ImportProspects';
import ProspectsList from '../pages/ProspectsList';

// render- Dashboard
const DashboardDefault = Loadable(lazy(() => import('pages/dashboard/default')));
const CompanyList = Loadable(lazy(() => import('pages/company-list')));
const CostCalculator = Loadable(lazy(() => import('pages/CostCalculator')));
const UserManagement = Loadable(lazy(() => import('pages/UserManagement')));
const ProductDeck = Loadable(lazy(() => import('pages/ProductDeck')));
const ProductDeckDetail = Loadable(lazy(() => import('pages/ProductDeckDetail')));
const SuperAdminSettings = Loadable(lazy(() => import('pages/SuperAdminSettings')));


// render - color
const Color = Loadable(lazy(() => import('pages/component-overview/color')));
const Typography = Loadable(lazy(() => import('pages/component-overview/typography')));
const Shadow = Loadable(lazy(() => import('pages/component-overview/shadows')));

// render - sample page
const SamplePage = Loadable(lazy(() => import('pages/extra-pages/sample-page')));

// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: '/',
  element: (
    <ProtectedRoute>
      <DashboardLayout />
    </ProtectedRoute>
  ),
  children: [
    {
      index: true,
      element: <DashboardDefault />
    },
    {
      path: 'dashboard',
      element: <DashboardDefault />
    },
    {
      path: 'companyList',
      element: <CompanyList />
    },
    {
      path: '/cost-calculator',
      element: <CostCalculator />
    },
    {
      path: '/user-management',
      element: <UserManagement />
    },
    {
      path: '/product-deck',
      element: <ProductDeck />
    },
    {
      path: '/product-deck/:id',
      element: <ProductDeckDetail />
    },
    {
      path: '/admin-settings',
      element: <SuperAdminSettings />
    },
    {
      path: '/import-prospects',
      element: <ImportProspects />
    },
    {
      path: '/prospects',
      element: <ProspectsList />
    },
    {
      path: '/account',
      element: <CompanyAcc />
    },
    {
      path: '/account/doctors',
      element: <CompanyAcc />
    },
    {
      path: '/appointmentList',
      element: <AppointmentList />
    },
    {
      path: '/offline-appointment',
      element: <OfflineAppointment />
    },
    {
      path: '/userlist',
      element: <UserList />
    },
    {
      path: '/testimonials',
      element: <TestimonialsList />
    },
    {
      path: '/company-settings',
      element: <CompanySettings />
    },
    {
      path: '/website-content',
      element: <WebsiteContent />
    },
    {
      path: '/import-bookings',
      element: <ImportBookings />
    },
    {
      path: '/appoint',
      element: <AppoinmentTest />
    },
    {
      path: 'typography',
      element: <Typography />
    },
    {
      path: 'color',
      element: <Color />
    },
    {
      path: 'shadow',
      element: <Shadow />
    },
    {
      path: 'sample-page',
      element: <SamplePage />
    }
  ]
};

export default MainRoutes;
